var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{attrs:{"border-variant":_vm.borderColor,"header":_vm.header,"no-body":_vm.noBody,"title":_vm.title},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }